import {Routes} from "@angular/router";
import {StoreCollectionEditComponent} from '../store-collection-edit/store-collection-edit.component';
import {StoreCollectionViewPurchasesComponent} from './store-collection-view-purchases/store-collection-view-purchases.component';
import {StoreCollectionViewInfoComponent} from './store-collection-view-info/store-collection-view-info.component';
import {routerHandler} from '../../../resources/utils/router';

export const StoreCollectionViewRoutesData: Routes = [
  routerHandler.redirect('store-collection'),
  routerHandler.info('store-collection', {component: StoreCollectionViewInfoComponent}),
  routerHandler.purchases('store-collection', {component: StoreCollectionViewPurchasesComponent}),
  routerHandler.edit('store-collection', {component: StoreCollectionEditComponent}),
];

export const StoreCollectionViewRoutes: Routes = Object.values(StoreCollectionViewRoutesData);
